import User from './variants/User';
import Admin from './variants/Admin';

export default {
  User,
  Admin
}